// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  jobId: __t.u64().primaryKey().name("job_id"),
  shipId: __t.u64().name("ship_id"),
  owner: __t.identity(),
  actor: __t.identity(),
  role: __t.string(),
  leaseId: __t.u64().name("lease_id"),
  epoch: __t.u32(),
  target: __t.string(),
  kitJson: __t.string().name("kit_json"),
  kitSerial: __t.string().name("kit_serial"),
  kitOwner: __t.identity().name("kit_owner"),
  fitRev: __t.string().name("fit_rev"),
  locSeq: __t.u32().name("loc_seq"),
  workMs: __t.u32().name("work_ms"),
  lastBeatMs: __t.f64().name("last_beat_ms"),
  requestId: __t.string().name("request_id"),
  startedAt: __t.timestamp().name("started_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
